'use strict';

var _ = require('lodash');
var LiveDataTimeHelperService = function LiveDataTimeHelperService(momentService) {
  function getOldestLastRefreshTime(lastRefreshTime) {
    var oldest;
    _.forOwn(lastRefreshTime, function (gridTime) {
      if (_.isNil(oldest) || !_.isNull(gridTime) && gridTime.isBefore(oldest)) {
        oldest = gridTime;
      }
    });
    return oldest.toISOString();
  }
  function transformStringTimestampIntoMoment(changeEntity) {
    return {
      id: changeEntity.id,
      modificationDateTime: momentService.of(changeEntity.modificationDateTime, momentService.FIELD.EVENT_TIME_STAMP)
    };
  }
  function transformChangesTimeStamps(data) {
    return {
      layer2Changes: _.map(data.layer2Changes, transformStringTimestampIntoMoment),
      layer3Changes: _.map(data.layer3Changes, transformStringTimestampIntoMoment)
    };
  }
  return {
    getOldestLastRefreshTime: getOldestLastRefreshTime,
    transformChangesTimeStamps: transformChangesTimeStamps
  };
};
LiveDataTimeHelperService.$inject = ['MomentService'];
module.exports = LiveDataTimeHelperService;